module.exports = __webpack_public_path__ + "assets/img/face_check_scene2.65e398cb.png";